// extracted by mini-css-extract-plugin
export var categoryIcon = "_dg-5";
export var connectorContainer = "_dg-1";
export var connectorLine = "_dg-0";
export var minHeight0 = "_dg-6";
export var relativeUnitValueSelector = "_dg-2";
export var trifoldSelectorBody = "_dg-4";
export var trifoldSelectorList = "_dg-3";